module.exports = __webpack_public_path__ + "media/images/logo-australia-7a0296f051f187fccec284791e2a545c.png";